import {
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";

import { useDialog } from "helper/customHook";
import { DIALOG } from "helper/enum/dialogEnum";
import React from "react";
import { useSelector } from "react-redux";
import { isOpenDialogSelector } from "redux-store/static/redux/selector";
import pxToRem from "theme/base/pxToRem";

interface PopupConfirmProps {
  title?: string;
  content?: string | React.ReactNode;
  buttonApprove?: string;
  styleTitle?: React.CSSProperties;
  styleContent?: React.CSSProperties;
  buttonReject?: string;
  onApprove?: () => void;
  onReject?: () => void;
  buttonApproveProps?: ButtonProps;
  buttonRejectProps?: ButtonProps;
}

export const ConfirmModal = ({
  title,
  styleTitle,
  styleContent,
  content,
  buttonApprove,
  buttonReject,
  onApprove,
  onReject,
  buttonApproveProps,
  buttonRejectProps,
}: PopupConfirmProps) => {
  const open = useSelector(isOpenDialogSelector(DIALOG.MODAL_CONFIRM));
  const approveDialog = useDialog(DIALOG.MODAL_CONFIRM);

  return (
    <Dialog open={open} onClose={() => approveDialog.close()} maxWidth="lg">
      <DialogTitle textAlign={"center"} sx={styleTitle}>
        {title}
      </DialogTitle>
      <Divider />
      {content && <DialogContent sx={styleContent}>{content}</DialogContent>}
      <DialogActions sx={{ padding: pxToRem(16) }}>
        <Button
          onClick={() => {
            approveDialog.close();
            onReject && onReject();
          }}
          fullWidth
          variant="contained"
          {...buttonRejectProps}
        >
          {buttonReject}
        </Button>
        <Button
          onClick={() => {
            approveDialog.close();
            onApprove && onApprove();
          }}
          fullWidth
          {...buttonApproveProps}
        >
          {buttonApprove}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
